import { recordPath, recordRoute } from '@/shared/registry'

/** Where Find Sent Notifications lives. */
export const sentMessagesPath = '/notifications/sent-messages'
export const sentMessageRoute = recordRoute('notifications', 'sent-messages')

/** One sent message. */
export function sentMessagePath(id: string): string {
  return recordPath('notifications', 'sent-messages', id)
}

/** Find Sent Notifications from Class Details: one class's messages. */
export const classSentMessagesRoute = '/notifications/classes/:classId/sent-messages'

export function classSentMessagesPath(classId: string): string {
  return `/notifications/classes/${encodeURIComponent(classId)}/sent-messages`
}

/** The base of a sent message's details slots (`detailsSlots`). */
export const sentMessageDetailsSlot = 'notifications.sent-message-details'

/** Finding sent messages. Everyone holds it for their own, so screens ask for a scope beyond that. */
export const readSentMessagesPermission = 'notifications.sent-message.read'
export const sentMessageAdminScopes = ['managedOrganizations', 'managedPeople', 'allOrganizations'] as const

/** The API's endpoints for sent messages. */
export const sentMessagesApi = '/notifications/v1/messages'

export function sentMessageApi(id: string): string {
  return `${sentMessagesApi}/${encodeURIComponent(id)}`
}

export function resendMessageApi(id: string): string {
  return `${sentMessageApi(id)}/resend`
}

export function classSentMessagesApi(classId: string): string {
  return `/notifications/v1/classes/${encodeURIComponent(classId)}/messages`
}
